// Onboarding de usuarios nuevos (rol "User"): guía de alta y recorrido por el menú.
// Estado persistido en localStorage por usuario (no hay campo en BD para esto).

const ONBOARDING_KEY_PREFIX = 'diiot:onboarding';

export const ONBOARDING_STEPS = {
  ENTITY: 0,
  LOCALITY: 1,
  DEVICE: 2,
  DONE: 3
};

const buildStorageKey = (userId) => `${ONBOARDING_KEY_PREFIX}:${userId ?? 'anonymous'}`;

const readState = (userId) => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(buildStorageKey(userId));
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    return {};
  }
};

const writeState = (userId, state) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(buildStorageKey(userId), JSON.stringify(state));
  } catch (error) {
    // no-op
  }
};

// Solo aplica al rol global "User" (Dm_Role: 3). System admin / User admin quedan fuera.
export const isPlainUserRole = (userData) => {
  if (!userData) return false;
  const normalizedRole = String(userData.Role ?? userData.role ?? '')
    .trim()
    .toLowerCase();
  const roleId = Number(userData.RoleId ?? userData.roleId ?? userData.UserRoleId ?? userData.userRoleId);
  return normalizedRole === 'user' || roleId === 3;
};

export const countUserDevices = (userData) => {
  const entities = Array.isArray(userData?.Entities) ? userData.Entities : [];
  return entities.reduce((total, entity) => {
    const localities = Array.isArray(entity?.Localities) ? entity.Localities : [];
    return total + localities.reduce((acc, locality) => acc + (Array.isArray(locality?.Devices) ? locality.Devices.length : 0), 0);
  }, 0);
};

const countUserLocalities = (userData) => {
  const entities = Array.isArray(userData?.Entities) ? userData.Entities : [];
  return entities.reduce((total, entity) => total + (Array.isArray(entity?.Localities) ? entity.Localities.length : 0), 0);
};

// Paso actual de la guía según lo que ya tiene creado el usuario.
export const getOnboardingStep = (userData) => {
  const entities = Array.isArray(userData?.Entities) ? userData.Entities : [];
  if (entities.length === 0) return ONBOARDING_STEPS.ENTITY;
  if (countUserLocalities(userData) === 0) return ONBOARDING_STEPS.LOCALITY;
  if (countUserDevices(userData) === 0) return ONBOARDING_STEPS.DEVICE;
  return ONBOARDING_STEPS.DONE;
};

// El usuario vio la guía vacía: queda "pendiente" el recorrido del menú cuando aparezca su primer datapoint.
// Así los usuarios que ya tenían dispositivos antes de esta funcionalidad no ven el recorrido.
export const markMenuTourPending = (userId) => {
  if (!userId) return;
  const state = readState(userId);
  if (state.menuTourPending || state.menuTourDone) return;
  writeState(userId, { ...state, menuTourPending: true });
};

export const shouldShowMenuTour = (userId) => {
  if (!userId) return false;
  const state = readState(userId);
  return Boolean(state.menuTourPending) && !state.menuTourDone;
};

export const markMenuTourDone = (userId) => {
  if (!userId) return;
  const state = readState(userId);
  writeState(userId, { ...state, menuTourPending: false, menuTourDone: true });
};
